import { envelope } from './index'

export default function GetItem(id) {
  return envelope`
    <m:GetItem>
     <m:ItemShape>
       <t:BaseShape>IdOnly</t:BaseShape>
       <t:AdditionalProperties>
         <t:FieldURI FieldURI="item:InReplyTo" />
         <t:FieldURI FieldURI="item:Attachments" />
         <t:FieldURI FieldURI="message:ToRecipients" />
         <t:FieldURI FieldURI="message:CcRecipients" />
         <t:FieldURI FieldURI="message:InternetMessageId"/>
       </t:AdditionalProperties>
     </m:ItemShape>
     <m:ItemIds>
       <t:ItemId Id="${id}" />
     </m:ItemIds>
   </m:GetItem>
  `
}

export function GetItemToEmailAddress(id) {
  return envelope`
    <m:GetItem>
     <m:ItemShape>
       <t:BaseShape>IdOnly</t:BaseShape>
       <t:AdditionalProperties>
         <t:FieldURI FieldURI="message:ToRecipients" />
       </t:AdditionalProperties>
     </m:ItemShape>
     <m:ItemIds>
       <t:ItemId Id="${id}" />
     </m:ItemIds>
   </m:GetItem>
  `
}
